<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >Account({{accountData.accountNumber}}) Offerings</h5>
              <div class="p-2">
                <div class="form-group">
                    <select class="form-control" @change="statusChange(status)" v-model="status" >
                        <option value="DELETED">DELETE</option>
                        <option value="HOLD">HOLD</option>
                        <option value="SUSPENDED">SUSPEND</option>
                    </select>
                </div>
              </div>
              <div class="p-2">  
                <button :disabled="accountOffferings.length == 0" type="button" @click="OfferingStatusChange()" class="btn btn-warning">{{statustext}} All</button>
                <button type="button" class="close"  @click="$emit('close')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>  
            </div>
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="text-center">CUSIP</th>
                    <th scope="col"  class="sort text-right">COST </th>
                    <th scope="col"  class="sort text-center">BOUGHT</th>
                    <th scope="col"  class="sort text-center">HOLDING QTY</th>
                    <th scope="col"  class="sort text-center">OFFERED QTY</th>
                    <th scope="col"  class="sort text-center">OFFERED PRICE</th>
                    <th scope="col"  class="sort text-center">SPREAD</th>
                    <th scope="col"  class="sort text-center">OFFER STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="accountOffferings.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr v-for="offer in accountOffferings" :key="offer.offerId">
                    <td><span class="cusips">{{offer.cusipVal}}</span></td>
                    <td class="text-right text-success">{{offer.cost ? offer.cost.toFixed(3) : 'N/A'}}</td>
                    <td class="text-center">{{moment(offer.boughtDate).format("MM/DD/YYYY") }}</td>
                    <td class="text-center">{{offer.quantity }}</td>
                    <td class="text-center text-success">{{offer.offerInventoryQuantity}}</td>
                    <td class="text-center">{{offer.offerPrice || 0}}</td>
                    <td class="text-center">{{(offer.offerPrice - offer.cost).toFixed(3)}}</td>
                    <td class="text-center">{{offer.offerStatus}}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
</template>

    <script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerOfferingsmodal',
        components :{
            
        },
        props: ['accountData'],
        data() {
            return {
                loading : false,
                errors: [],
                accountOffferings : [],
                totalRecords : null,
                status : "DELETED",
                statustext : "DELETE"
            };
        },
        methods: {  
          statusChange(status){
            if(status == 'DELETED'){
              this.statustext = "DELETE"
            }
            if(status == 'SUSPENDED'){
              this.statustext = "SUSPEND"
            }
             if(status == 'HOLD'){
              this.statustext = "HOLD"
            }

          },
          getCustomerOfferings(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/account-offer-list?accountMappingId="+this.accountData.accountMappingId,
                auth
            )
            .then(result => {
              this.accountOffferings = result.data;
              this.loading = false;
            })
          },
          OfferingStatusChange(){
              this.$confirm("Are you sure you want to "+this.statustext+" all offerings created with this account("+this.accountData.accountNumber+")?","","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                let postData = {"status":this.status,"cognitoSub":authService.getUser().cognitoSub,"accountMappingId":this.accountData.accountMappingId}
                this.$http
                .put(
                config.baseUrlBidSide +
                    "/offer/suspend-account-mapping-offerings",
                   postData,
                    auth
                )
                .then(() => {
                  this.$alert(this.statustext+" in progress");
                  this.$emit('close');
                  this.loading = false;
                })
              });
          }
        },
        mounted(){
          this.getCustomerOfferings();
        }
    };
    </script>